import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  TermsOfService,
  Modal,
  IconSpinner,
  PrimaryButton,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { connect } from 'react-redux';
import { compose } from 'redux';


import css from './ClaimPage.module.css';
import CalimForm from './ClaimForm';
import axios from 'axios';
import { getWinery, makeClaimRequest } from '../../services/winery';
import AfterSubmitionMsg from './AfterSubmitionMsg/AfterSubmitionMsg';
import { claimPageEmailTemplate, claimPageEmailTemplateForAdmin } from '../../util/emailTemplates';


const ClaimPage = ({
  onManageDisableScrolling,
  scrollingDisabled,
  currentUser,
  params,
  admin,
  wineryOwner,
}) => {
  const {id} = params;
  const [winery, setWinery] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  // const [formValues, setFormValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [makeClaimRequestLoading, setMakeClaimRequestLoading] = useState(false);

  const [tosModalOpen, setTosModelOpen] = useState(false)
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    getWinery(id, setLoading, setWinery)
  }, []);

  useEffect(() => {
    if(winery !== null) {
      setInitialValues({
        ...initialValues,
        fname: "",
        lname: "",
        bw: "",
        phone: "",
        wineryName: winery?.name,
        title: "",
        email: currentUser?.attributes.email,
        // email: '',
      })
    }
  }, [winery, currentUser])

  const handleOnChangeIsAgreed = (e) => {
    setIsAgreed(e.target.checked)
  }

  const handleSubmitClaimRequest = async (formValues) => {
    const obj = {
      ...formValues,
      agree: isAgreed,
      winery: winery?._id,
      user: currentUser?.expresUserId,
      sharetribeUserId: currentUser?.id.uuid
    }

    await makeClaimRequest(obj, setMakeClaimRequestLoading, setWinery, winery);
    setTimeout(() => {
      setTosModelOpen(false);
      fetch('https://hooks.zapier.com/hooks/catch/11291651/bsrun9b/', {
        method: 'POST',
        body: JSON.stringify({
          emailto: currentUser?.attributes.email,
          emailFrom: "support@sommly.com",
          subject: 'Winery Claim Request',
          body: claimPageEmailTemplate(currentUser?.attributes.profile.displayName)
        })
      })
      .then( res => res.json())
      .catch(err => {
        console.log(err);
      })
    }, 100);

    setTimeout(() => {
      setTosModelOpen(false);
      fetch('https://hooks.zapier.com/hooks/catch/11291651/bsrun9b/', {
        method: 'POST',
        body: JSON.stringify({
          emailFrom: currentUser?.attributes.email,
          emailto: 'support@sommly.com',
          subject: 'Winery Claim Request',
          body: claimPageEmailTemplateForAdmin(currentUser?.attributes.profile.displayName,  winery?.name)
        })
      })
      .then( res => res.json())
      .catch(err => {
        console.log(err);
      })
    }, 200);
  };
  return (
    <Page
        title='Claim Your Business | Sommly TM'
        scrollingDisabled={scrollingDisabled}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'Claim Page',
          name: 'Claim Your Business | Sommly TM',
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain className={css.layoutWrapperMain}>
            <div className={css.root}>
              <div className={css.content}>
                {loading ? (
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: "40px"}}>
                    <IconSpinner />
                  </div>
                ) : (
                  <>
                    {winery?.claimed === 'claim' || winery?.claimed === 'rejected' ? (
                      <CalimForm
                        onSubmit={handleSubmitClaimRequest}
                        inProgress={makeClaimRequestLoading}
                        onOpenTermsOfService=""
                        initialValues={initialValues}
                        admin={admin}
                        wineryOwner={wineryOwner}
                        handleOnChangeIsAgreed={handleOnChangeIsAgreed}
                        isAgreed={isAgreed}
                      />
                    ) : (
                      <AfterSubmitionMsg />
                    )}
                  </>
                )}
              </div>
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
  )
}

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { admin, wineryOwner } = state.Auth;
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    admin,
    wineryOwner,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  // injectIntl
)(ClaimPage);
